import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { BaseCellRendererComponent } from './base_cell_renderer.component';
import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgxPopperjsDirective, NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers } from 'ngx-popperjs';
import { PopperHelper } from '@nts/std/utility';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
// create your cellEditor as a Angular component@UntilDestroy()
@UntilDestroy()
@Component({
    selector: 'nts-numeric-text-box-renderer-cell',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgxPopperjsModule,
        NgFor,
        NgIf,
        AsyncPipe
    ],
    styles: [`
        .numeric-alignment {
            text-align: right;
            flex: 1;
        }
    `],
    template: `
        <span>
            <div *ngIf="!params?.data" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </span>
        <div *ngIf="params?.data" class="read-template">
            <div class="renderer-cell"
                #popperError="popper"
                [popper]="tooltipErrTemplate"
                popperAppendTo="body"
                popperApplyClass="error"
                [popperPreventOverflow]="false"
                [popperHideOnScroll]="true"
                [popperDisabled]="!propertyViewModel?.hasErrors"
                [popperTrigger]="ngxPopperjsTriggers.hover"
                [popperPlacement]="ngxPopperjsPlacements.TOP">
                <div class="numeric-alignment">{{ propertyViewModel?.formattedValue }}</div>
            </div>

            <popper-content #tooltipErrTemplate>
                <div *ngFor="let item of propertyViewModel?.errors$ | async">
                    {{ item }}
                </div>
            </popper-content>
        </div>`
})
export class NumericCellRendererComponent extends BaseCellRendererComponent implements OnDestroy {

    @ViewChild('popperError', { static: false }) popperError: NgxPopperjsDirective;

    ngxPopperjsTriggers = NgxPopperjsTriggers;
    ngxPopperjsPlacements = NgxPopperjsPlacements;

    constructor(
        private readonly cd: ChangeDetectorRef,
        public readonly el: ElementRef,
        private readonly renderer: Renderer2) {
        super();
    }

    override agInit(params: any): void {
        super.agInit(params);
        if (this.params?.data) {
            merge(
                this.propertyViewModel.propertyChanged,
                this.propertyViewModel.customGetterValueChanged
            ).pipe(
                takeUntil(this.destroy$),
            ).subscribe(() => {
                this.cd.detectChanges();
            });

            this.propertyViewModel.onFocusRequested.pipe(
                untilDestroyed(this),
            ).subscribe(() => {
                // Si sposta sulla riga
                this.el.nativeElement.parentElement.parentElement.scrollIntoView();

                if (this.propertyViewModel?.hasErrors) {
                    PopperHelper.show(this.popperError);
                }
            });
        }
    }
}
